import React from 'react';
import { Navigate } from 'react-router-dom';
import { usuarioSignal } from '../../../signals/usuario';

const ProtectedRoute = ({ component: Component, funcionalidade, predicado }) => {
    const rbac = usuarioSignal.value.rbac;
    const permitido = predicado ? predicado(rbac) : Boolean(funcionalidade && rbac.temPermissao(funcionalidade));
    return permitido ? <Component /> : <Navigate replace to="/nao-autorizado" />;
};

export default ProtectedRoute;
